import { render, staticRenderFns } from "./Objects.vue?vue&type=template&id=452cb5bc&scoped=true"
import script from "./Objects.js?vue&type=script&lang=js&external"
export * from "./Objects.js?vue&type=script&lang=js&external"
import style0 from "./Objects.scss?vue&type=style&index=0&id=452cb5bc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452cb5bc",
  null
  
)

export default component.exports